import { createReducer } from 'redux-act';

import {
  PLAN_FETCH_DATA_INIT,
  PLAN_FETCH_DATA_SUCCESS,
  PLAN_FETCH_DATA_FAIL,
  PLAN_DELETE_INIT,
  PLAN_DELETE_SUCCESS,
  PLAN_DELETE_FAIL,
  PLAN_CLEAR_DATA,
  PLAN_CREATE_INIT,
  PLAN_CREATE_SUCCESS,
  PLAN_CREATE_FAIL,
  PLAN_MODIFY_INIT,
  PLAN_MODIFY_SUCCESS,
  PLAN_MODIFY_FAIL,
  PLAN_CLEAN_UP,
  PLAN_CLEAR_DATA_LOGOUT
} from '../../actions/plans';

const initialState = {
  data: [],
  loading: false,
  error: null,
  success: false,
  deleted: false
};

export const plansReducer = createReducer(
  {
    [PLAN_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true
    }),
    [PLAN_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.plans,
      loading: false,
      error: null
    }),
    [PLAN_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [PLAN_DELETE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [PLAN_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.filter(elem => elem.id !== payload.id),
      loading: false,
      error: null,
      deleted: true
    }),
    [PLAN_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [PLAN_CLEAR_DATA]: state => ({
      ...initialState,
      data: state.data
    }),
    [PLAN_CREATE_INIT]: state => ({
      ...state,
      loading: true
    }),
    [PLAN_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.concat(payload),
      loading: false,
      error: null,
      success: true
    }),
    [PLAN_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [PLAN_MODIFY_INIT]: state => ({
      ...state,
      loading: true
    }),
    [PLAN_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      data: state.data.map(elem => {
        if (elem.id === payload.id) {
          return payload;
        }
        return elem;
      }),
      loading: false,
      error: null,
      success: true
    }),
    [PLAN_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error
    }),
    [PLAN_CLEAN_UP]: state => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false
    }),
    [PLAN_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState
    })
  },
  initialState
);
